import React from "react";

// there only dialog functionality using there, it is not related to mmc modal
// eslint-disable-next-line no-restricted-imports
import Modal, { ModalProps } from "antd/es/modal";
import cn from "classnames";

import styles from "./EmbeddedModal.module.scss";

type EmbeddedModalProps = Omit<
  ModalProps,
  | "centered"
  | "footer"
  | "mask"
  | "maskClosable"
  | "modalRender"
  | "title"
  | "visible"
  | "width"
  | "wrapClassName"
>;

export const EmbeddedModal = ({ className, ...props }: EmbeddedModalProps) => {
  return (
    <Modal
      {...props}
      centered={false}
      className={cn(styles.modal, className)}
      closable={false}
      footer={null}
      mask={false}
      maskClosable={false}
      title={null}
      width="100vw"
      wrapClassName={styles.modalWrapper}
    />
  );
};

export default EmbeddedModal;
